import { useState, useRef } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";
import StawkaNew from "./StawkaNew";

import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";


import edit from "../../edit.png";
import trash from "../../trash.png";


function ContractMassStawka(props)
{

   
    const [stawki, setStawki]     = useState(null);
    const [subkonta, setSubkonta] = useState(null);


    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState( {

        ids: props.ids,
        newStawka: '_x_',
        stawki: [],

    });


    const valChangeListener = (filedName, val, correct, msg) => { 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }


    const valChangeListenerStawka = (filedName, val, correct, msg) => { 
        console.log("valChangeListenerStawka: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      
        //setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );  
        
        var exp = filedName.split('@');
        var id = exp[0];
        var filed = exp[1];

        console.log(id, filed, val);

        for(var k=0; k<row.stawki.length; k++)
        {
            if(row.stawki[k].id == id ) 
            {
                row.stawki[k][filed] = val;
            }
        }

        setRow( {...row, ["stawki"]: row.stawki } );

    }




    const getSubkonta = () => {
       
 
        props.mainView.setProgress(-2);

        
        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,subkonta', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setSubkonta(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const getStawki = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,stawki', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') setStawki(res.result);   
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(subkonta == null) {
        setSubkonta([])
        getSubkonta();
        return <span>...</span>
    }


    if(stawki == null) {
        setStawki([])
        getStawki();
        return <span>...</span>
    }



    const stDelete = (e) => {

        var idx = e.target.getAttribute('id');

        //var oldTab = JSON.stringify(row.stawki);
        var newArr = new Array();

        for(var k=0; k<row.stawki.length; k++)
        {
            if(row.stawki[k].id == idx ) continue

            newArr.push(row.stawki[k]);
        }

        setRow( {...row, ["stawki"]: newArr  } );

    }



    const saveData = () => {

       
 

        if(row.stawki.length < 1) 
                {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wybierz min. jedną stawkę' ,  "ok"  ,null); 
                    return; 
                }            
 

      


        props.mainView.setProgress(-2);

      

        fetch( Config.url + '/rest_v1_calc,umowa_dodaj_stawki', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Wybrane umowy zostały zaktualizowane', "ok" , null); 
                                props.onBack();
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }









    var arrStawki = new Array();

    var sRow = {
        v: "_x_",
        title: ' - - - ',
    }
    arrStawki.push(sRow);
    

    for(var sI=0; sI<stawki.length; sI++)
    {

        for(var kI=0; kI<subkonta.length; kI++)
            {
                   var nVal = stawki[sI]['id'] + "___" + subkonta[kI]['id'];

                    var sRow = {
                        v: nVal,
                        title: stawki[sI]['nazwa'] + " | " + stawki[sI]['kwota_netto']  + "zł | "+  subkonta[kI]['nazwa'] +" / " +subkonta[kI]['numer_konta'] +" ",
                    }
            
                    arrStawki.push(sRow);


                    if(row.newStawka != '_x_' && row.newStawka == nVal) // cos wybrano.. wiec z automatu dodaj do tablicy..
                        {
                            var oldTab = JSON.stringify(row.stawki);
                            oldTab = JSON.parse(oldTab);
                            oldTab.push(
                                {
                                    id: nVal,

                                    p_typy_oplat:  stawki[sI]['id'], 
                                    nazwa_stawki:  stawki[sI]['nazwa'], 
                                    kwota_netto:  stawki[sI]['kwota_netto'], 
                                    naliczanie_dzienne:  stawki[sI]['naliczanie_dzienne'], 
                                    naliczanie_miesieczne:  stawki[sI]['naliczanie_miesieczne'], 
                                    naliczanie_godzinowe:  stawki[sI]['naliczanie_godzinowe'], 
                                    naliczanie_nadgodzin:  stawki[sI]['naliczanie_nadgodzin'], 
                                    naliczanie_jednorazowe:  stawki[sI]['naliczanie_jednorazowe'], 
                                    rozliczaj_normalnie:  stawki[sI]['rozliczaj_normalnie'], 
                                    naliczanie_wlasne:  stawki[sI]['naliczanie_wlasne'], 
                                    naliczanie_wlasne_symbol:  stawki[sI]['naliczanie_wlasne_symbol'], 

                                    p_subkonta_id: subkonta[kI]['id'], 
                                    nazwa_konta:   subkonta[kI]['nazwa'], 
                                    numer_konta:   subkonta[kI]['numer_konta'], 

                                    data_od: null,
                                    data_do: null,
                                }
                            );
                       
                            setRow({...row, ["stawki"]: oldTab, ["newStawka"]:'_x_' });                       
                          
                        }

            }   
    }   
 
    var reqStawka = '1';
    if(row.stawki.length >0 ) reqStawka = '0';







    return  <div className="view_content">
            <h1><PlTitle userData={props.userData} /> / Operacja masowa / Dodanie stawki</h1>


            <div className="form_tab_title">Wybrano umów: ({props.ids.length}) </div>    
            
            <div className="form_tab">
                <div className="scroll200">
                <ul>
                {
                    props.ids.map( (item, ix) => {
                        return <li>
                                {item.title }
                        </li>
                    } )
                }
                </ul>
                </div>
            </div>

            <div className="form_tab">
                

                    <table className="table" >
                            <tr>
                                <td>
                                        Przypisz nową,  min. jedną z istniejących stawek:  <InputCombo   items={arrStawki}  value={row.newStawka} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="newStawka" placeholder={""} className=' ' req={reqStawka}   />
                                </td>

                                <td className="gocenter">LUB</td>
                                
                                <td className="goright">
                                        <StawkaNew  userData={props.userData} mainView={props.mainView} onAdded={getStawki} />                                                        
                                </td>
                            </tr>
                        </table>

                        <br/>                   
                        { row.stawki.length > 0 && 
                        <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td>LP</td>
                                                <td>Nazwa stawki</td>  
                                                <td>Sposób naliczania</td>                                                                                     
                                                <td>Kwota</td>   
                                                <td>Powiązane konto</td>                                               
                                                <td>Naliczanie OD**</td>                                               
                                                <td>Naliczanie DO**</td>                                               
                                                <td></td>                                                                                   
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                row.stawki.map( (st, ix) => {


                                                    var sp = '';
                                                    if(st.naliczanie_jednorazowe == '1')   sp = "Jednorazowo";
                                                    if(st.naliczanie_dzienne == '1')       sp = "Dziennie";
                                                    if(st.naliczanie_miesieczne == '1')    sp = "Miesięcznie";
                                                    if(st.naliczanie_godzinowe == '1')    sp = "Godzinowe";
                                                    if(st.naliczanie_nadgodzin == '1')    sp = "Nadgodzinowe";
                                                    if(st.naliczanie_wlasne == '1')    sp = "Własne";

                                                    return <tr className="row">
                                                                <td className="gocenter">{ix+1}</td>
                                                                <td className="gocenter">{st.nazwa_stawki}</td>  
                                                                <td className="gocenter">{sp}</td>                                                                                     
                                                                <td className="goright">{st.kwota_netto}</td>   
                                                                <td className="gocenter">{st.nazwa_konta + ", " + st.numer_konta}</td>  


                                                                <td className="gocenter">                                                                    
                                                                    <InputDate   userData={props.userData} value={st.data_od} err={[]}  valChange={valChangeListenerStawka} goNext={null} name={ st.id + "@data_od"  } placeholder={""} className=' ' req='0'   />
                                                                </td>                                               

                                                                <td className="gocenter">
                                                                    <InputDate   userData={props.userData} value={st.data_do} err={[]}  valChange={valChangeListenerStawka} goNext={null} name={ st.id + "@data_do"  } placeholder={""} className=' ' req='0'   />
                                                                </td>      



                                                                <td><img className="ibtn" src={trash} title="Usuń"   onClick={stDelete} v="delete" id={st.id}  /> </td>   

                                                    </tr>
                                                }  )
                                            }
                                        </tbody>

                        </table>
                        }

                        <br/>
                        <div>
                            **Pozostaw puste jeżeli stawka ma obowiązywać przez cały okres umowy. Okres ten możesz zawsze później zmienić. 
                        </div>


                        <br/>        
                        <br/>        

                        <div className="form_control">                                            
                                <div className="btn" onClick={saveData}>dodaj</div>
                                &nbsp; &nbsp;
                                <div className="btn" onClick={props.onBack}>anuluj</div>
                        </div>

            </div>
       
    </div>
}



export default ContractMassStawka;